module.exports = __webpack_public_path__ + "static/media/learn-months-spanish.0ac2fd48.jpg";